<template>
    <div class="feedback-container-ths">
        <PageLoader v-if="processing" />
        <FeedbackHeader :survey-already-completed="surveyAlreadyCompleted" :backLink=true :title="$t('checking_in')" v-on:goBack="goBack" :stepProgress="stepProgress" :maxStepsCount="maxStepsCount" />
        <div class="container is-centered feedback full-height">

            <div class="feedback-content has-margin-top-30">

                <div v-show="stepProgress <= maxStepsCount" class="">
                    <component
                        v-bind:is="currentStepComponent"
                        :showEmptyError="showEmptyError"
                        :feedback-data="currentSurveyQuestions[stepProgress - 1]"
                        :saved-answer="currentAnswer"
                        :survey-passing-id="surveyPassingId"
                        v-on:showFeedback="openAddFeedbackStep"
                        v-on:hideError="hideError"
                        v-on:updateProgress="setCanProgress"
                        ref="currentComponent"
                    />
                </div>

                <StepAddFeedback
                    v-if="showAddFeedback"
                    :feedback-data="currentSurveyQuestions[stepProgress - 1]"
                    :saved-answer="currentAnswer"
                    :feedback="feedbackText"
                    v-on:updateProgress="setCanProgress"
                    ref="stepAddFeedback"
                />

                <div
                    class="add-feedback__link"
                    @click="clickFeedbackLink"
                    v-if="showAddFeedbackLink"
                >
                    Add feedback
                </div>

                <StepEnd
                    v-if="stepProgress === maxStepsCount + 1"
                    :survey-already-completed="surveyAlreadyCompleted"
                    :saved-answers="savedAnswers"
                />
            </div>

            <div class="feedback-footer has-margin-bottom-25">
                <b-button
                    :class="{ disabled: !canProgress }"
                    class="button-ths--link"
                    type="is-danger"
                    expanded
                    @click="footerBtnAction(false)"
                    >{{ footerBtnName }}</b-button
                >
            </div>
        </div>
    </div>
</template>

<script>
import StepAddFeedback from "@/components/feedback/StepAddFeedback";
import StepYesNo from "@/components/feedback/StepYesNo";
import StepNoOrTags from "@/components/feedback/StepNoOrTags";
import StepScale from "@/components/feedback/StepScale";
import StepOnlyFeedback from "@/components/feedback/StepOnlyFeedback";
import StepScaleStars from "@/components/feedback/StepScaleStars";
import StepEnd from "@/components/feedback/StepEnd";
import PageLoader from "@/components/PageLoader";
import FeedbackHeader from '@/components/FeedbackHeader.vue'

export default {
    name: "FeedbackPage",
    data() {
        return {
            processing: false,
            stepProgress: 1,
            currentStep: "yesno",
            feedbackText: "",
            savedAnswers: [],
            showAddFeedback: false,
            showAddFeedbackLink: false,
            surveyAlreadyCompleted: false,
            showEmptyError: false,
            timeoutId: null,
            langMessages: this.$i18n.locale,
            canProgress: false,
        };
    },
    components: {
        StepAddFeedback,
        StepYesNo,
        StepNoOrTags,
        StepScaleStars,
        StepScale,
        StepOnlyFeedback,
        PageLoader,
        StepEnd,
        FeedbackHeader,
    },
    mounted() {
        if (this.isAuthenticated) {
            this.processing = true;
            Promise.all([
                this.$store.dispatch("getCurrentSurvey", { id: 1 }),
                this.$store.dispatch("getCurrentSurveyAnswers", { id: 1 }),
            ]).finally(() => {
                this.processing = false;

                this.defineCurrentStep();
            });
        } else {
            this.$router.push("/sign-in");
        }
    },
    computed: {
        maxStepsCount() {
            return (
                (this.currentSurveyQuestions &&
                    this.currentSurveyQuestions.length) ||
                3
            );
        },
        footerBtnName() {
            return this.stepProgress <= this.maxStepsCount
                ? this.$i18n.messages[this.$store.state.lang.locale].next
                : this.$i18n.messages[this.$store.state.lang.locale].finish;
        },
        currentSurvey() {
            return this.$store.state.feedback.currentSurvey;
        },
        currentAnswer() {
            if (this.savedAnswers) {
                let currentAnswer = this.savedAnswers.find((answ) => {
                    return (
                        answ.question_id ==
                        (this.currentStep && this.currentStep.id)
                    );
                });
                return (currentAnswer && currentAnswer.answer_data) || null;
            }
            return 0;
        },
        currentSurveyQuestions() {
            let currentSurveyQuestions =
                this.currentSurvey && this.currentSurvey.questions;
            return currentSurveyQuestions || [];
        },
        currentSurveyAnswers() {
            return this.$store.state.feedback.currentSurveyAnswers;
        },
        currentStepComponent() {
            if (
                this.currentStep &&
                this.currentStep.type &&
                this.currentStep.type.name
            ) {
                switch (this.currentStep.type.name) {
                    case "Yes No":
                    default:
                        return "StepYesNo";
                    case "No or Tags":
                        return "StepNoOrTags";
                    case "Scale Stars":
                        return "StepScaleStars";
                    case "Scale":
                        return "StepScale";
                    case "Only Feedback":
                        return "StepOnlyFeedback";
                }
            }
            return "StepYesNo";
        },
        showAddFeedbackBtn() {
            return !this.showAddFeedback;
        },
        isAuthenticated() {
            return !!this.$store.state.auth.accessToken;
        },
        surveyPassingId() {
            return (
                (this.savedAnswers &&
                    this.savedAnswers[0] &&
                    this.savedAnswers[0].survey_passing_id) ||
                null
            );
        },
    },
    methods: {
        setCanProgress(value) {
            /* console.log('setCanProgress'); */
            if (this.currentStepComponent === "StepNoOrTags" && !value) {
                /* console.log('setCanProgress StepNoOrTags set false'); */
                if (this.$refs.currentComponent.selectedTags.length < 1 && this.$refs.stepAddFeedback.feedbackText === '') { 
                    /* console.log('setCanProgress StepNoOrTags no tags no feedback'); */
                    this.canProgress = value;
                }
            }
            /* else if (this.currentStepComponent === "StepOnlyFeedback") {
                console.log('Feedback only step');

            } */
            else {
                this.canProgress = value;
            }
        },
        defineCurrentStep() {
            if (
                this.currentSurveyAnswers &&
                this.currentSurveyAnswers.answers &&
                this.currentSurveyAnswers.answers.length
            ) {
                if (this.currentSurveyAnswers.answers.length === this.maxStepsCount) {
                    this.surveyAlreadyCompleted = true;
                }

                let self = this;
                let arr = this._lodash.map(this.currentSurveyQuestions, function(item){
                    let answ = self._lodash.find(self.currentSurveyAnswers.answers,
                        question => {return question.question_id == item.id});
                    if (answ && answ.answer_data) {
                        item['answer_data'] = answ.answer_data;
                    }
                    return item;
                });
                let indexOfQuestionWithNoAnswer = this._lodash.findIndex(arr, item => !item.answer_data);
                if(indexOfQuestionWithNoAnswer === -1) {
                    this.stepProgress = this.maxStepsCount + 1;
                } else if(indexOfQuestionWithNoAnswer) {
                    this.stepProgress = indexOfQuestionWithNoAnswer + 1;
                } else {
                    this.stepProgress =
                        this.currentSurveyAnswers.answers.length + 1;
                }
            }
            this.currentStep = this.currentSurveyQuestions[
                this.stepProgress - 1
            ];
            this.savedAnswers =
                this.currentSurveyAnswers && this.currentSurveyAnswers.answers;
        },
        footerBtnAction(needSkip = false) {
            console.log('footerBtnAction');
            if (this.stepProgress <= this.maxStepsCount) {
                console.log('more steps to go');
                if (this.canProgress) {
                    console.log('canProgress true');
                    if (this.showAddFeedback) {
                        console.log('saveFeedback');
                        this.saveTextFeedback();
                    }
                    else {
                        console.log('don\'t saveFeedback');
                    }
                    this.continueStep(needSkip);
                }
            } else {
                /* console.log('no more steps so closePage'); */
                this.closePage();
            }
        },
        saveStepAnswer(needSkip) {
            console.log('saveStepAnswer');
            clearTimeout(this.timeoutId);
            this.showEmptyError = false;
            if (
                this.$refs.currentComponent &&
                this.$refs.currentComponent.stepResult
            ) {
                console.log('have current component and a stepResult');
                let newStepResult = this.$refs.currentComponent.stepResult;

                this.processing = true;
                if (!needSkip) {
                    console.log('needSkip false');
                    if (
                        this.$refs.currentComponent &&
                        this.$refs.currentComponent.canContinue
                    ) {
                        console.log('currentComponent and currentComponent.canContinue true: dispatch');
                        this.$store
                            .dispatch(
                                "saveFeedback",
                                this._lodash.assign(newStepResult, {
                                    feedback: this.feedbackText,
                                }),
                            )
                            .then((response) => {
                                this.savedAnswers = this._lodash.reject(
                                    this.savedAnswers,
                                    { question_id: response.data.question_id },
                                );
                                this.savedAnswers.push(response.data);
                                this.stepProgress = this.stepProgress + 1;
                                this.currentStep = this.currentSurveyQuestions[
                                    this.stepProgress - 1
                                ];
                                this.processing = false;
                            })
                            .catch((err) => {
                                if (
                                    err.message ===
                                    "Answer on this question already exists."
                                ) {
                                    this.stepProgress = this.stepProgress + 1;
                                    this.currentStep = this.currentSurveyQuestions[
                                        this.stepProgress - 1
                                    ];
                                }
                                this.processing = false;
                            });
                    } else {
                        this.processing = false;
                        this.showEmptyError = true;
                    }
                } else {
                    this.stepProgress = this.stepProgress + 1;
                    this.currentStep = this.currentSurveyQuestions[
                        this.stepProgress - 1
                    ];
                    this.processing = false;
                }
            }
        },
        continueStep(needSkip) {
            this.saveStepAnswer(needSkip);
        },
        clickFeedbackLink(show) {
            this.showAddFeedbackLink = false;
            this.openAddFeedbackStep(show);
        },
        openAddFeedbackStep(show) {
            /* if (this.stepProgress === 1) { */
            /* if (this.stepProgress === 2) { */
                this.showAddFeedback = show
            /* } */
        },
        saveTextFeedback() {
            this.feedbackText =
                this.$refs.stepAddFeedback &&
                this.$refs.stepAddFeedback.feedbackText;

            this.showAddFeedback = false;
        },
        closePage() {
            this.$store.dispatch("logout").finally(() => {
                this.$router.push({ name: "sign-in" });
            });
        },
        goBack() {
            if (this.stepProgress !== 1) {
                /* if (this.showAddFeedback) {
                    this.showAddFeedback = false;
                } else { */
                    this.stepProgress = this.stepProgress - 1;

                    this.currentStep = this.currentSurveyQuestions[
                        this.stepProgress - 1
                    ];

                    if (this.stepProgress !== 2) {
                        this.showAddFeedback = true;
                    }
                /* } */
            }
            this.hideError()
        },
        hideError() {
            this.showEmptyError = false;
        }
    },
    watch: {
        stepProgress() {
            /* console.log("stepProgress()"); */
            if (this.savedAnswers) {
                /* console.log("stepProgress() savedAnswers"); */
                let currentAnswer = this.savedAnswers.find((answ) => {
                    return (
                        answ.question_id ==
                        (this.currentStep && this.currentStep.id)
                    );
                });
                this.feedbackText =
                    (currentAnswer && currentAnswer.feedback) || "";

                (currentAnswer === undefined) ? this.canProgress = false : this.canProgress = true;

                if (this.stepProgress > this.maxStepsCount)
                    this.canProgress = true
            } else {
                this.feedbackText = "";
            }
            switch (this.currentStep.type.name) {
                case "Yes No":
                case "Scale":
                default:
                    this.showAddFeedbackLink = false;
                    this.openAddFeedbackStep(false);
                    break;
                case "Scale Stars":
                    this.showAddFeedbackLink = true;
                    this.openAddFeedbackStep(false);
                    if (this.feedbackText !== '') {
                        this.showAddFeedbackLink = false;
                        this.openAddFeedbackStep(true);
                    }
                    else {
                        this.showAddFeedbackLink = true;
                        this.openAddFeedbackStep(false);
                    }
                    break;
                case "No or Tags":
                    this.showAddFeedbackLink = false;
                    this.openAddFeedbackStep(true);
                    break;
                case "Only Feedback":
                    this.setCanProgress(true);
                    this.showAddFeedbackLink = false;
                    this.openAddFeedbackStep(true);
                    break;
            }
        },
    },
};
</script>

<style scoped></style>
